import React from 'react';
import { SUPPORTED_WALLETS } from '../../utils/constants';

interface WalletModalProps {
  onConnect: (walletName: string) => void;
  onClose?: () => void;
}

export const WalletModal: React.FC<WalletModalProps> = ({ onConnect }) => {
  return (
    <div className="wallet-modal">
      <div className="wallet-grid grid grid-cols-1 md:grid-cols-2 gap-4">
        {SUPPORTED_WALLETS.map((wallet) => (
          <div
            key={wallet.name}
            className="wallet-card bg-surface border border-border rounded-lg p-6 cursor-pointer transition-all duration-300 hover:transform hover:-translate-y-2 hover:border-gold/40 hover:shadow-lg"
            onClick={() => onConnect(wallet.name)}
          >
            <div className="wallet-icon flex items-center justify-center w-12 h-12 bg-gold/10 text-gold rounded-full mx-auto mb-4">
              <i className={wallet.icon}></i>
            </div>
            
            <div className="wallet-name text-lg font-semibold text-white mb-2">
              {wallet.name}
            </div>
            
            <div className="wallet-status text-xs text-text-secondary bg-gold/10 px-2 py-1 rounded-full inline-block">
              Popular
            </div>
          </div>
        ))}
      </div>
      
      <div className="wallet-footer text-center pt-6 border-t border-border">
        <p className="text-xs text-text-secondary">
          By connecting a wallet, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
};